import { useLocation } from "react-router-dom";

import { CMP_PRACTITIONER_URL, CMP_AFFILIATE_URL } from "@/core/urls";

export default function usePartnerPageCheck(
  { excludeApplicationPages = true } = {
    excludeApplicationPages: true
  }
) {
  const location = useLocation();
  return (
    (location.pathname.startsWith("/patients") || location.pathname.startsWith("/cmp")) &&
    (excludeApplicationPages
      ? ![CMP_PRACTITIONER_URL, CMP_AFFILIATE_URL].includes(location.pathname)
      : true)
  );
}
